import { InjectionToken, Provider } from '@angular/core';
import { SignageContext } from '../types/signage-context';

export const SIGNAGE_CONTEXT = new InjectionToken<SignageContext>('Signage context');

export const SIGNAGE_CONTEXT_DEFAULT: Provider = {
  provide: SIGNAGE_CONTEXT,
  useValue: 'default' as SignageContext
};

export const SIGNAGE_CONTEXT_PREVIEW: Provider = {
  provide: SIGNAGE_CONTEXT,
  useValue: 'preview' as SignageContext
};
